import Swal from 'sweetalert2';

export default {
    multiLanguage: null,

    Start(title) {
        Swal.fire({
            title: title || this.multiLanguage.get('wait'),
            allowOutsideClick: false,
            allowEscapeKey: false,
            onBeforeOpen: () => Swal.showLoading()
        });
    },

    Stop() {
        Swal.close();
    },

    ShowErrorMessage(message) {
        let messageToShow = message || this.multiLanguage.get('unexpectedError');

        Swal.fire({
            type: 'error',
            title: 'Oppsss!',
            text: messageToShow
        });
    }
};
